import React from 'react';

const TextArea = ({ label, type, placeholder, id, handleChange, name, value }) => {
    return (
      <div className='flex flex-col gap-1 w-full'>
        <label className='h6-jost'>{label}</label>
        <textarea
          className='w-full body-jost-small appearance-none placeholder:text-gray-40 bg-dark min-h-[6.5rem] h-auto px-3 border-b border-b-gray focus:outline-none focus:border-b-2 valid:border-b-2 focus:bg-gray5 resize-none overflow-auto break-words'
          placeholder={placeholder}
          id={id}
          onChange={handleChange}
          required
          name={name}
          value={value}
        />
      </div>
    );
  };
  

export default TextArea;